import { createReduxHistory } from '../routing-setup';
import { store } from './store-setup';

export const browserHistory = createReduxHistory(store);
